import { FC, useEffect, useState } from 'react';
import { PeselStatus } from './usePeselCheck';
import { PeselSlide } from '@/eventConfig/types.ts';
import { translate } from '@/translation/translate';

interface PeselCheckResultProps {
  peselStatus: PeselStatus;
  slide: PeselSlide;
}

export const PeselCheckResult: FC<PeselCheckResultProps> = ({ peselStatus, slide }) => {
  const [peselResultText, setPeselResultText] = useState('');

  useEffect(() => {
    switch (peselStatus) {
      case 'not-registered':
        setPeselResultText(translate(slide.peselResultTexts?.notRegistered));
        break;

      case 'already-registered-other':
        setPeselResultText(translate(slide.peselResultTexts?.registeredWithOther));
        break;

      case 'already-registered-dkms':
        setPeselResultText(translate(slide.peselResultTexts?.registeredWithDKMS));
        break;

      case 'poltransplant-offline':
        setPeselResultText(translate(slide.peselResultTexts?.failed));
        break;

      case 'invalid':
        setPeselResultText(translate(slide.peselResultTexts?.invalid));
        break;

      default:
        setPeselResultText(translate(''));
        break;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [peselStatus]);

  return <div className="col-12 pesel-result">{peselResultText}</div>;
};
